import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class SitiosService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/sitios/'
    }

}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/ladecuador-dev/src/app/shared/services/api/sitio.service.ts